import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "capacity"
const CapacityIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15 18C15.414 18 15.75 18.336 15.75 18.75V21.75C15.75 22.164 15.414 22.5 15 22.5S14.25 22.164 14.25 21.75V21H4.5V21.75C4.5 22.164 4.164 22.5 3.75 22.5S3 22.164 3 21.75V18.75C3 18.336 3.336 18 3.75 18S4.5 18.336 4.5 18.75V19.5H14.25V18.75C14.25 18.336 14.586 18 15 18" />
          <path
            fillRule="evenodd"
            d="M15 2.25C15.828 2.25 16.5 2.922 16.5 3.75V15C16.5 15.828 15.828 16.5 15 16.5H3.75C2.922 16.5 2.25 15.828 2.25 15V3.75C2.25 2.922 2.922 2.25 3.75 2.25zM3.75 15H15V3.75H3.75z"
            clipRule="evenodd"
          />
          <path d="M21.75 14.25C22.164 14.25 22.5 14.586 22.5 15S22.164 15.75 21.75 15.75H18.75C18.336 15.75 18 15.414 18 15S18.336 14.25 18.75 14.25H19.5V4.5H18.75C18.336 4.5 18 4.164 18 3.75S18.336 3 18.75 3H21.75C22.164 3 22.5 3.336 22.5 3.75S22.164 4.5 21.75 4.5H21V14.25z" />
        </svg>
      }
    </span>
  )
}
export default CapacityIcon
